/* Soraya – COZY heated wearable blanket landing section */
(function () {
  function init(root) {
    if (!root || root.dataset.scInit) return;
    root.dataset.scInit = '1';

    /* gallery: thumbnails swap the hero image */
    var hero = root.querySelector('[data-sc-hero]');
    var thumbs = root.querySelectorAll('[data-sc-thumb]');
    Array.prototype.forEach.call(thumbs, function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        if (hero && src) hero.src = src;
        Array.prototype.forEach.call(thumbs, function (o) {
          o.classList.toggle('is-active', o === t);
        });
      });
    });

    /* bundle: radio selection drives price display */
    var radios = root.querySelectorAll('[data-sc-variant]');
    var priceEl = root.querySelector('[data-sc-price]');
    var compareEl = root.querySelector('[data-sc-compare]');

    function sync() {
      var picked = root.querySelector('[data-sc-variant]:checked');
      if (!picked) return;
      if (priceEl) priceEl.textContent = picked.getAttribute('data-price');
      var cmp = picked.getAttribute('data-compare');
      if (compareEl) {
        compareEl.textContent = cmp || '';
        compareEl.hidden = !cmp;
      }
      Array.prototype.forEach.call(radios, function (r) {
        var label = r.closest('label');
        if (label) label.classList.toggle('is-selected', r.checked);
      });
    }

    Array.prototype.forEach.call(radios, function (r) {
      r.addEventListener('change', sync);
    });
    sync();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.sc'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* theme editor support */
  document.addEventListener('shopify:section:load', boot);
})();
